module.exports = __webpack_public_path__ + "static/media/founder.fb6e44be.jpg";